import { render } from "./BookingsPatientsTable.vue?vue&type=template&id=384732a2&scoped=true"
import script from "./BookingsPatientsTable.vue?vue&type=script&lang=js"
export * from "./BookingsPatientsTable.vue?vue&type=script&lang=js"

import "./BookingsPatientsTable.vue?vue&type=style&index=0&id=384732a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-384732a2"

export default script